<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import appConfig from "@/app.config"

// Re-export from config for backward compatibility
export { getBackendUrl, url } from './config.js';
export default {
  name: "app",
  mounted() {
    try {
      const params = new URLSearchParams(window.location.search);
      const kioskParam = params.get("kiosk");
      const kioskEnabled = kioskParam === "1" || kioskParam === "true" || window.self !== window.top;
      document.body.classList.toggle("cc360-kiosk", kioskEnabled);
    } catch {
      // no-op
    }
  },
  page: {
    // All subcomponent titles will be injected into this template.
    // Hello
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  }
};
</script>
